import type { GiftSellingPlan } from "../../lib/types";
import { groupPlansByName } from "./groupPlansByName";

/** Options for a plan `<Select>`, one `<optgroup>` per selling plan group. */
export const SellingPlanOptions = ({ plans }: { plans: readonly GiftSellingPlan[] }) => (
	<>
		{[...groupPlansByName(plans)].map(([groupName, groupPlans]) => (
			<optgroup key={groupName} label={groupName}>
				{groupPlans.map((plan) => (
					<option key={plan.gid} value={plan.gid}>
						{plan.name ?? "Plan"}
					</option>
				))}
			</optgroup>
		))}
	</>
);
